"use client";

import React, {useState, useEffect, useMemo} from 'react';
import {Container} from './container';
import Image from 'next/image';
import Link from 'next/link';
import {cn} from "@/shared/lib/utils";
import {Button} from "@/shared/components/ui/button";
import CarFormModal from "@/shared/components/ui/car-form-modal";
import UniversalBookingModal from "@/shared/components/ui/universal-booking-modal";

interface Props {
    className?: string;
}

interface MenuProps {
    isOpen: boolean;
    toggleMenu: () => void;
    setIsModalOpen: () => void;
    setIsModalFormRecallOpen: () => void;
    setIsUniversalBookingOpen: () => void;
}

const Menu = ({isOpen, toggleMenu, setIsModalOpen, setIsModalFormRecallOpen, setIsUniversalBookingOpen}: MenuProps) => {
    // Блокировка скролла при открытом меню
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <div
            className={`fixed inset-0 z-40 transition-all duration-300 ${
                isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
            }`}
            style={{
                backdropFilter: 'blur(26px)',
                WebkitBackdropFilter: 'blur(26px)',
                background: '#252525A1'
            }}
        >
            <Container className={'pt-22 pb-72'}>
                <Image src={'/images/close.svg'} alt={'закрыть'} width={90} height={90}
                       className={'ml-auto cursor-pointer'} onClick={toggleMenu}/>
                <div className={'grid grid-cols-4 gap-9 h-full mt-32'}>
                    <Link href={'tel:+74232222999'}>
                        <Button variant={'outlineWhiteNoHover'}
                                className={'h-[296px] px-[81px] py-[130px] lg:text-[32px] leading-[1.2] rounded-[40px] font-normal relative group overflow-hidden disabled:hover'}>
                            Позвонить
                            <span
                                className="absolute inset-0 rounded-[40px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                                style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                            />
                        </Button>
                    </Link>
                    <Button variant={'outlineWhiteNoHover'}
                            onClick={() => { 
                                window.open('https://wa.me/74232222999', '_blank');
                                toggleMenu();
                            }}
                            className={'h-[296px] px-[71px] py-[130px] lg:text-[32px] leading-[1.2] rounded-[40px] font-normal relative group overflow-hidden disabled:hover'}>
                        написать в whatsapp
                        <span
                            className="absolute inset-0 rounded-[40px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                            style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                        />
                    </Button>
                    <Button variant={'outlineWhiteNoHover'}
                            onClick={() => { setIsUniversalBookingOpen(); toggleMenu(); }}
                            className={'h-[296px] px-[71px] py-[130px] lg:text-[32px] leading-[1.2] rounded-[40px] font-normal relative group overflow-hidden disabled:hover'}>
                        записаться онлайн
                        <span
                            className="absolute inset-0 rounded-[40px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                            style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                        />
                    </Button>
                    <Button variant={'outlineWhiteNoHover'}
                            onClick={setIsModalOpen}
                            className={'h-[296px] px-[71px] py-[130px] lg:text-[32px] leading-[1.2] rounded-[40px] font-normal relative group overflow-hidden disabled:hover'}>
                        экспертная консультация
                        <span
                            className="absolute inset-0 rounded-[40px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                            style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                        />
                    </Button>
                    <Button variant={'outlineWhiteNoHover'}
                            onClick={() => {
                                const [lat, lon] = [43.117964, 131.931110];
                                const url = `https://yandex.ru/maps/?rtext=~${lat},${lon}&rtt=auto`;
                                window.open(url, '_blank');
                                toggleMenu();
                            }}
                            className={'w-full col-span-2 px-[40px] py-[47px] lg:text-[32px] leading-[1.2] rounded-[27px] font-normal relative group overflow-hidden disabled:hover'}>
                        построить маршрут
                        <span
                            className="absolute inset-0 rounded-[27px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                            style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                        />
                    </Button>
                    <Button variant={'outlineWhiteNoHover'}
                            onClick={setIsModalFormRecallOpen}
                            className={'w-full col-span-2 px-[40px] py-[47px] lg:text-[32px] leading-[1.2] rounded-[27px] font-normal relative group overflow-hidden disabled:hover'}>
                        заказать обратный звонок
                        <span
                            className="absolute inset-0 rounded-[27px] bg-gradient-to-br from-transparent from-40% via-transparent to-[rgba(255,98,0,0.65)] to-94% opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"
                            style={{background: 'linear-gradient(150.17deg, rgba(255, 98, 0, 0) 39.83%, rgba(255, 98, 0, 0.65) 93.89%)'}}
                        />
                    </Button>
                </div>
            </Container>
        </div>
    )
}

const MenuMobile = ({isOpen, toggleMenu}: MenuProps) => {
    // Блокировка скролла при открытом меню
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <div
            className={`fixed inset-0 z-40 transition-all duration-300 ${
                isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
            }`}
            style={{
                backdropFilter: 'blur(26px)',
                WebkitBackdropFilter: 'blur(26px)',
                background: '#252525A1'
            }}
        >
            <Container className={'h-full pt-8 pb-8 flex flex-col'}>
                <Image src={'/images/close.svg'} alt={'закрыть'} width={36} height={36}
                       className={'ml-auto cursor-pointer'} onClick={toggleMenu}/>
                <div className={'flex justify-center items-center mt-auto mb-auto'}>
                    <div
                        className={'flex flex-col  ml-auto mr-auto text-start text-white uppercase text-[30px] font-bold'}>
                        <Link href="/#about" className="hover:text-gray-300 transition-colors mb-7" onClick={toggleMenu}>
                            О нас
                        </Link>
                        <Link href="/#services" className="hover:text-gray-300 transition-colors mb-7" onClick={toggleMenu}>
                            Услуги
                        </Link>
                        <Link href="/#promotions" className="hover:text-gray-300 transition-colors mb-7" onClick={toggleMenu}>
                            Акции
                        </Link>
                        <Link href="/#pricing" className="hover:text-gray-300 transition-colors mb-7" onClick={toggleMenu}>
                            Цена
                        </Link>
                    </div>
                </div>
            </Container>
        </div>
    )
}

const MenuContactMobile = ({isOpen, toggleMenu, setIsModalOpen, setIsModalFormRecallOpen, setIsUniversalBookingOpen}: MenuProps) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <div
            className={`fixed inset-0 z-40 transition-all duration-300 ${
                isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
            }`}
            style={{
                backdropFilter: 'blur(26px)',
                WebkitBackdropFilter: 'blur(26px)',
                background: '#252525A1'
            }}
        >
            <Container className={'h-full pl-0 pr-0 pt-8 pb-8 flex flex-col'}>
                <Image src={'/images/close.svg'} alt={'закрыть'} width={36} height={36}
                       className={'ml-auto cursor-pointer mr-8'} onClick={toggleMenu}/>
                <div className={'flex mt-auto mb-auto'}>
                    <div className={'flex flex-col text-white uppercase text-[24px] leading-[1.2]'}>
                        <Link href={'tel:+74232222999'} onClick={toggleMenu} className={'border-b-1 w-100 pl-5 pb-3'}>Позвонить</Link>
                        <Link href={'#'} onClick={(e) => { 
                            e.preventDefault();
                            const [lat, lon] = [43.117964, 131.931110];
                            const url = `https://yandex.ru/maps/?rtext=~${lat},${lon}&rtt=auto`;
                            window.open(url, '_blank');
                            toggleMenu();
                        }} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>Построить маршрут</Link>
                        <Link href={"#"} onClick={setIsModalOpen} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>экспертная консультация</Link>
                        <Link href={'#'} onClick={setIsModalFormRecallOpen} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>заказать обратный звонок</Link>
                        <Link href={'#'} onClick={(e) => { e.preventDefault(); setIsUniversalBookingOpen(); toggleMenu(); }} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>записаться онлайн</Link>
                        <Link href={'#'} onClick={(e) => { e.preventDefault(); window.open('https://wa.me/74232222999', '_blank'); toggleMenu(); }} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>написать в whatsapp</Link>
                        <Link href={'/schedule-autofest'} onClick={toggleMenu} className={'border-b-1 w-100 pl-5 pb-3 pt-3'}>узнать расписание фестивалей</Link>
                        <Link href={'https://autogarantcity.ru'} onClick={toggleMenu} className={'w-100 pl-5 pb-3 pt-3'}>перейти на сайт автогарантсити</Link>
                    </div>
                </div>
            </Container>
        </div>
    )
}

export const Header: React.FC<React.PropsWithChildren<Props>> = ({className}) => {
    const [state, setState] = useState({
        isOpen: false,
        isOpenMobileMenu: false,
        isOpenContactMobileMenu: false,
        isModalFormOpen: false,
        isModalFormRecallOpen: false,
        isUniversalBookingOpen: false
    });

    const stateValues = useMemo(() => ({
        isOpen: state.isOpen,
        isOpenMobileMenu: state.isOpenMobileMenu,
        isOpenContactMobileMenu: state.isOpenContactMobileMenu,
        isModalFormOpen: state.isModalFormOpen,
        isModalFormRecallOpen: state.isModalFormRecallOpen,
        isUniversalBookingOpen: state.isUniversalBookingOpen
    }), [state]);

    const {
        isOpen,
        isOpenMobileMenu,
        isOpenContactMobileMenu,
        isModalFormOpen,
        isModalFormRecallOpen,
        isUniversalBookingOpen
    } = stateValues;

    const toggleMenu = () => {
        setState(prev => ({ ...prev, isOpen: !prev.isOpen }));
    };

    const toggleMenuMobile = () => {
        setState(prev => ({ ...prev, isOpenMobileMenu: !prev.isOpenMobileMenu }));
    };

    const toggleMenuContactMobile = () => {
        setState(prev => ({ ...prev, isOpenContactMobileMenu: !prev.isOpenContactMobileMenu }));
    };

    const toggleModalForm = () => {
        setState(prev => ({ ...prev, isModalFormOpen: !prev.isModalFormOpen }));
    };

    const toggleModalFormRecall = () => {
        setState(prev => ({ ...prev, isModalFormRecallOpen: !prev.isModalFormRecallOpen }));
    };

    const toggleUniversalBooking = () => {
        setState(prev => ({ ...prev, isUniversalBookingOpen: !prev.isUniversalBookingOpen }));
    };

    return (
        <>
            <header className={cn("fixed top-0 left-0 right-0 z-30 bg-[rgba(38,38,38,0.51)] backdrop-blur-[6.1px]", className)}>
                <Container className="flex items-stretch justify-between pt-4 pb-4">
                    <Link href="/" className="flex items-stretch self-stretch">
                        <div className={'flex items-stretch gap-2 lg:gap-3 self-stretch'}>
                            <p className={'text-white uppercase font-bold text-[8px] lg:text-[13px] leading-tight self-center'}><span className="whitespace-nowrap">первая современная</span><br/>станция экспресс услуг
                            </p>
                            <span className={'bg-custom-black leading-none text-white px-6 md:px-8 h-[34px] lg:h-[56px] font-bold text-[20px] md:text-[28px] lg:text-[38px] uppercase flex items-center justify-center self-center'}>f1</span>
                        </div>
                    </Link>
                    <nav className="flex items-center gap-4 xl:gap-8 hidden lg:flex ml-4 xl:ml-8">
                        <div className="flex items-center gap-4 xl:gap-8 text-md xl:text-lg uppercase text-white font-button">
                            <Link href="/#about" className="hover:text-gray-300 transition-colors whitespace-nowrap">
                                О нас
                            </Link>
                            <Link href="/#services" className="hover:text-gray-300 transition-colors">
                                Услуги
                            </Link>
                            <Link href="/#promotions" className="hover:text-gray-300 transition-colors">
                                Акции
                            </Link>
                            <Link href="/#pricing" className="hover:text-gray-300 transition-colors">
                                Цена
                            </Link>
                        </div>
                    </nav>
                    <div className="flex items-center gap-4 xl:gap-9 ml-4 xl:ml-8 hidden lg:flex">
                        <Button variant={'outlineWhite'}
                                onClick={toggleMenu}
                                className={'pt-3 pb-3 pl-4 pr-4 xl:pt-4 xl:pb-4 xl:pl-8 xl:pr-8 text-md xl:text-lg font-button leading-none flex items-center justify-center self-center'}>
                            <Image src={'/images/phone-white.svg'} alt={'контакты'} width={23} height={23}
                                   className={'mr-2 xl:mr-4'}/>
                            Контакты
                        </Button>
                        <Button 
                            variant={'filledWhite'}
                            onClick={toggleUniversalBooking}
                            className={'pt-3 pb-3 pl-4 pr-4 xl:pt-4 xl:pb-4 xl:pl-8 xl:pr-8 text-md xl:text-lg font-button leading-none flex items-center justify-center self-center'}>
                            <Image src={'/images/phone-black.svg'} alt={'запись'} width={23} height={23}
                                   className={'mr-2 xl:mr-4'}/>
                            Записаться
                        </Button>
                    </div>
                    <div className={'flex items-center gap-3 lg:hidden'}>
                        <Image 
                            src="/images/contact.svg" 
                            alt="Записаться" 
                            width={28} 
                            height={28}
                            onClick={toggleUniversalBooking}
                            className="cursor-pointer"
                        />
                        <Image src="/images/people.svg"
                               alt="Контакты"
                               width={28}
                               height={28}
                               className={'cursor-pointer'}
                               onClick={toggleMenuContactMobile}
                        />
                        <Image src="/images/menu.svg"
                               alt="Меню"
                               width={28}
                               height={28}
                               className={'cursor-pointer'}
                               onClick={toggleMenuMobile}
                        />
                    </div>
                </Container>
            </header>
            <Menu isOpen={isOpen} toggleMenu={toggleMenu} setIsModalOpen={toggleModalForm} setIsModalFormRecallOpen={toggleModalFormRecall} setIsUniversalBookingOpen={toggleUniversalBooking}/>
            <MenuMobile isOpen={isOpenMobileMenu} toggleMenu={toggleMenuMobile} setIsModalOpen={toggleModalForm} setIsModalFormRecallOpen={toggleModalFormRecall} setIsUniversalBookingOpen={toggleUniversalBooking}/>
            <MenuContactMobile isOpen={isOpenContactMobileMenu} toggleMenu={toggleMenuContactMobile} setIsModalOpen={toggleModalForm} setIsModalFormRecallOpen={toggleModalFormRecall} setIsUniversalBookingOpen={toggleUniversalBooking}/>
            <CarFormModal title={'Запись на экспертную консультацию'} isOpen={isModalFormOpen} onClose={toggleModalForm} showCarFields={false}/>
            <CarFormModal title={'Заказать обратный звонок'} isOpen={isModalFormRecallOpen} onClose={toggleModalFormRecall} showCarFields={false}/>
            <UniversalBookingModal isOpen={isUniversalBookingOpen} onClose={toggleUniversalBooking} blockName="Шапка сайта"/>
        </>
    );
}